import { strokeWidth } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P, Pivot, R } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
export class TapeMeasure {
    render(appearance) {
        const { length: cmlength } = appearance;
        const length = cmlength * 10;
        const tape = Shape.Rectangle(R(-5, 0, length + 5, 25));
        tape.withStroke(strokeWidth("thinner"), "#8c6d2e")
            .withFill("#f9cb01");
        const tapeEnd = Shape.Rectangle(R(length + 7, 5, 20, 15, Pivot.TOP_RIGHT), 2)
            .withFill("#222222");
        const casing = Shape.Rectangle(R(-71, -3, 70, 31), 2.0);
        casing.withStroke(strokeWidth("default"), "#333333")
            .withGradientFill("right", Gradients.box("#444444".color()));
        const graphic = new Group([tape]);
        // Add markings
        let mark = 1;
        let markX = length - 10;
        while (markX > 0) {
            const color = mark % 10 == 0 ? "red" : "black";
            graphic.addChild(new Path.Line(P(markX, 0), P(markX, 10)).withStroke(strokeWidth("thinner"), color));
            markX -= 10;
            mark += 1;
        }
        graphic.addChild(tapeEnd);
        graphic.addChild(casing);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            pivot: casing.bounds.center,
        };
    }
}
TapeMeasure.properties = {
    label: "Tape measure",
    defaultAppearance: {
        length: 30,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "length", label: "Length",
            min: 0, max: 90, unit: "cm"
        }
    ],
};
